import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createBlock as _createBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-64bf3a88"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "biz-table-set-field-dialog" }
const _hoisted_2 = {
  key: 0,
  class: "settings-dialog-checkbox",
  style: {"margin-bottom":"20px"}
}
const _hoisted_3 = { class: "settings-dialog-checkbox" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { style: {"margin-top":"20px"} }
const _hoisted_6 = { class: "settings-dialog-checkbox" }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = { class: "settings-dialog-right" }
const _hoisted_9 = { style: {"display":"flex","justify-content":"space-between","align-items":"center","margin-bottom":"10px","box-sizing":"border-box","padding":"0 20px"} }
const _hoisted_10 = { style: {"font-family":"PingFang SC, PingFang SC","font-weight":"600","font-size":"14px","color":"#121619","line-height":"22px","text-align":"left","font-style":"normal","text-transform":"none"} }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "不可排序字段", -1))
const _hoisted_12 = { class: "settings-dialog-item" }
const _hoisted_13 = { style: {"display":"flex","align-items":"center"} }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "https://cdn.myxrk.com/myxrk-v2/front-end/assets/oss/topic/svg/yidong.svg",
    class: "icon itemMove",
    style: {"cursor":"move","margin":"-3px 10px 0 0","width":"16px","height":"16px"}
  })
], -1))

import { ref, onMounted, nextTick, computed } from 'vue';
import { Close } from '@element-plus/icons-vue';
import {
  BaseDialog,
  BaseTextContent,
  BaseButton,
  BaseCheckbox,
  BaseScrollbar,
  BaseIcon,
  XrkTableProps,
  BaseToolTip
} from 'xrk-components';
import _ from 'lodash';
import Draggable from 'vuedraggable';

import { storage } from '@/utils/storage';
import { TableColumnsItem } from '../../index';
import {
  useSetTableConfig,
  getColumnsCheckedKey,
  isSkip
} from '../hooks/index';


export default /*#__PURE__*/_defineComponent({
  __name: 'biz-table-set-field',
  props: {
    remove: {},
    tableColumns: {},
    searchColumns: {},
    baseTitle: { default: '基础信息' },
    otherTitle: { default: '其他信息' },
    storeKey: {}
  },
  emits: ['success'],
  setup(__props: any, { emit: __emit }) {

const props = __props;
const emits = __emit;

const overStyle = ref<any>({
  overflow: 'hidden',
  'text-overflow': 'ellipsis',
  '-webkit-box-orient': 'vertical',
  display: '-webkit-box',
  'line-clamp': 1,
  'white-space': 'initial',
  'word-break': 'break-all'
});

const isDrag = ref(false);
const checkedList = ref<TableColumnsItem[]>([]);
const disabledTableColumns = ref<TableColumnsItem[]>([]);
const baseTableColumns = ref<TableColumnsItem[]>([]);
const otherTableColumns = ref<TableColumnsItem[]>([]);

onMounted(() => {
  const checkedKeys = storage.get(getColumnsCheckedKey(props.storeKey));
  const _tableColumns = _.cloneDeep(props.tableColumns);
  for (let index = 0; index < _tableColumns.length; index++) {
    const item = _tableColumns[index];
    if (!item?._sign || isSkip(item)) continue;

    if (item._disabled) {
      disabledTableColumns.value.push(item);
      continue;
    }

    if (item?._sign === 'base') {
      baseTableColumns.value.push(item);
    } else if (item?._sign === 'other') {
      otherTableColumns.value.push(item);
    }

    if (checkedKeys) {
      const obj = checkedKeys.find(val => val.prop === item.prop);
      item._checked = obj ? 1 : 0;
      if (obj) {
        checkedList.value.push({
          ...item,
          _sort: obj?._sort || item._sort
        });
      }
    } else {
      if (item._checked === 1) checkedList.value.push(item);
    }
  }

  disabledTableColumns.value?.sort((a, b) => a._sort - b._sort);
  baseTableColumns.value?.sort((a, b) => a._sort - b._sort);
  otherTableColumns.value?.sort((a, b) => a._sort - b._sort);
  checkedList.value?.sort((a, b) => a._sort - b._sort);
});

const checkedAllModelValue = computed(() => {
  return columns => {
    return checkedList.value.some(item => {
      return columns.some(val => item.prop === val.prop);
    });
  };
});
const indeterminateBase = computed(() => {
  return columns => {
    const len = checkedList.value.filter(item =>
      columns.some(val => val.prop === item.prop)
    ).length;

    return len && len !== columns.length;
  };
});
const onCheckAll = columns => {
  const indeterminate = indeterminateBase.value(columns);
  const flag = !checkedAllModelValue.value(columns);

  columns.forEach(item => {
    const index = checkedList.value.findIndex(val => val.prop === item.prop);

    if (flag || indeterminate) {
      item._checked = 1;
      if (index === -1) checkedList.value.push(item);
    } else {
      item._checked = 0;
      if (index !== -1) checkedList.value.splice(index, 1);
    }
  });

  if (flag) {
    nextTick(() => {
      const el = document.querySelectorAll('.settings-dialog-item');
      el?.[el.length - 1]?.scrollIntoView({
        block: 'start',
        inline: 'start',
        behavior: 'smooth'
      });
    });
  }
};
const onCheckboxChange = (item: TableColumnsItem) => {
  item._checked = !item._checked ? 1 : 0;

  if (item._checked) {
    checkedList.value.push(item);

    nextTick(() => {
      const el = document.querySelectorAll('.settings-dialog-item');
      el?.[el.length - 1]?.scrollIntoView({
        block: 'start',
        inline: 'start',
        behavior: 'smooth'
      });
    });
  } else {
    const index = checkedList.value.findIndex(val => val.prop === item.prop);
    if (index !== -1) checkedList.value.splice(index, 1);
  }
};

const onClearCheckedList = () => {
  checkedList.value = [];
  baseTableColumns.value.forEach(item => {
    item._checked = 0;
  });
  otherTableColumns.value.forEach(item => {
    item._checked = 0;
  });
};
const onDeleteItem = (key: string, value: TableColumnsItem) => {
  const index = checkedList.value.findIndex(val => val.prop === key);
  if (index !== -1) checkedList.value.splice(index, 1);

  const currentObj = (
    value._sign === 'base' ? baseTableColumns.value : otherTableColumns.value
  ).find(item => item.prop === value.prop);
  if (currentObj) currentObj._checked = 0;
};

const onCancel = () => {
  props?.remove?.();
};
const onConfirm = () => {
  const startIndex = disabledTableColumns.value?.length
    ? Math.max(...disabledTableColumns.value.map(item => item._sort))
    : 0;
  const checkedKeys = checkedList.value.map((item, index) => {
    return {
      prop: item.prop,
      _sort: startIndex + index + 1
    };
  });
  const { newSearchColumns, newTableColumns } = useSetTableConfig({
    checkedKeys,
    tableColumns: props.tableColumns,
    searchColumns: props.searchColumns
  });

  storage.set(getColumnsCheckedKey(props.storeKey), checkedKeys);
  emits('success', {
    newSearchColumns,
    newTableColumns
  });
  onCancel();
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(BaseDialog), {
    title: "设置显示字段",
    width: "960px",
    "model-value": true,
    "before-close": onCancel
  }, {
    footer: _withCtx(() => [
      _createVNode(_unref(BaseButton), {
        type: "default",
        onClick: onCancel
      }, {
        default: _withCtx(() => [
          _createTextVNode("取消")
        ]),
        _: 1
      }),
      _createVNode(_unref(BaseButton), { onClick: onConfirm }, {
        default: _withCtx(() => [
          _createTextVNode("确定")
        ]),
        _: 1
      })
    ]),
    default: _withCtx(() => [
      _createVNode(_unref(BaseTextContent), null, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createVNode(_unref(BaseScrollbar), { class: "settings-dialog-left" }, {
              default: _withCtx(() => [
                (disabledTableColumns.value.length)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      (disabledTableColumns.value.length)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(disabledTableColumns.value, (item) => {
                              return (_openBlock(), _createElementBlock("div", {
                                style: {"cursor":"not-allowed"},
                                key: item.prop
                              }, [
                                (_openBlock(), _createBlock(_unref(BaseCheckbox), {
                                  key: item.prop,
                                  disabled: true,
                                  "true-value": 1,
                                  "false-value": 0,
                                  modelValue: item._checked,
                                  "onUpdate:modelValue": ($event: any) => ((item._checked) = $event)
                                }, null, 8, ["modelValue", "onUpdate:modelValue"])),
                                _createVNode(_unref(BaseToolTip), {
                                  content: item.label,
                                  "over-show": "",
                                  enterable: false,
                                  style: _normalizeStyle(overStyle.value)
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(item.label), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["content", "style"])
                              ]))
                            }), 128))
                          ]))
                        : _createCommentVNode("", true)
                    ], 64))
                  : _createCommentVNode("", true),
                _createElementVNode("p", null, _toDisplayString(_ctx.baseTitle), 1),
                (baseTableColumns.value.length)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _createElementVNode("div", {
                        class: "checkbox-all",
                        onClick: _cache[0] || (_cache[0] = ($event: any) => (onCheckAll(baseTableColumns.value)))
                      }, [
                        _createVNode(_unref(BaseCheckbox), {
                          modelValue: checkedAllModelValue.value(baseTableColumns.value),
                          indeterminate: indeterminateBase.value(baseTableColumns.value)
                        }, null, 8, ["modelValue", "indeterminate"]),
                        _createTextVNode(" 全选 ")
                      ]),
                      _createElementVNode("div", _hoisted_3, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(baseTableColumns.value, (item) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: item.prop,
                            onClick: ($event: any) => (onCheckboxChange(item))
                          }, [
                            _createVNode(_unref(BaseCheckbox), {
                              "true-value": 1,
                              "false-value": 0,
                              modelValue: item._checked
                            }, null, 8, ["modelValue"]),
                            _createVNode(_unref(BaseToolTip), {
                              content: item.label,
                              "over-show": "",
                              enterable: false,
                              style: _normalizeStyle({
                    ...overStyle.value
                  })
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(item.label), 1)
                              ]),
                              _: 2
                            }, 1032, ["content", "style"])
                          ], 8, _hoisted_4))
                        }), 128))
                      ])
                    ], 64))
                  : _createCommentVNode("", true),
                (otherTableColumns.value.length)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                      _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.otherTitle), 1),
                      _createElementVNode("div", {
                        class: "checkbox-all",
                        onClick: _cache[1] || (_cache[1] = ($event: any) => (onCheckAll(otherTableColumns.value)))
                      }, [
                        _createVNode(_unref(BaseCheckbox), {
                          modelValue: checkedAllModelValue.value(otherTableColumns.value),
                          indeterminate: indeterminateBase.value(otherTableColumns.value)
                        }, null, 8, ["modelValue", "indeterminate"]),
                        _createTextVNode(" 全选 ")
                      ]),
                      _createElementVNode("div", _hoisted_6, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(otherTableColumns.value, (item) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: item.prop,
                            onClick: ($event: any) => (onCheckboxChange(item))
                          }, [
                            _createVNode(_unref(BaseCheckbox), {
                              "true-value": 1,
                              "false-value": 0,
                              modelValue: item._checked
                            }, null, 8, ["modelValue"]),
                            _createVNode(_unref(BaseToolTip), {
                              content: item.label,
                              "over-show": "",
                              enterable: false,
                              style: _normalizeStyle({
                    ...overStyle.value
                  })
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(item.label), 1)
                              ]),
                              _: 2
                            }, 1032, ["content", "style"])
                          ], 8, _hoisted_7))
                        }), 128))
                      ])
                    ], 64))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }),
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("p", _hoisted_10, " 已选字段（" + _toDisplayString(checkedList.value.length) + "） ", 1),
                _createVNode(_unref(BaseButton), {
                  type: "text",
                  onClick: onClearCheckedList
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" 清空 ")
                  ]),
                  _: 1
                })
              ]),
              _createVNode(_unref(BaseScrollbar), { style: {
              height: 'calc(100% - 35px)',
              boxSizing: 'border-box',
              padding: '0 20px'
            } }, {
                default: _withCtx(() => [
                  (disabledTableColumns.value.length)
                    ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(disabledTableColumns.value, (item) => {
                        return (_openBlock(), _createElementBlock("div", {
                          class: "settings-dialog-item",
                          style: {"font-family":"PingFang SC, PingFang SC","font-weight":"400","font-size":"14px","color":"#878d96","line-height":"22px","text-align":"left","font-style":"normal","text-transform":"none"},
                          key: item.prop
                        }, [
                          _createElementVNode("p", null, [
                            _createVNode(_unref(BaseToolTip), {
                              content: item.label,
                              "over-show": "",
                              enterable: false,
                              style: _normalizeStyle(overStyle.value)
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(item.label), 1)
                              ]),
                              _: 2
                            }, 1032, ["content", "style"])
                          ]),
                          _hoisted_11
                        ]))
                      }), 128))
                    : _createCommentVNode("", true),
                  _createVNode(_unref(Draggable), {
                    list: checkedList.value,
                    animation: 200,
                    handle: ".itemMove",
                    itemKey: "prop",
                    forceFallback: true,
                    "ghost-class": "ghost",
                    onStart: _cache[2] || (_cache[2] = ($event: any) => (isDrag.value = true)),
                    onEnd: _cache[3] || (_cache[3] = ($event: any) => (isDrag.value = false))
                  }, {
                    item: _withCtx(({ element: item }) => [
                      _createElementVNode("div", _hoisted_12, [
                        _createElementVNode("p", _hoisted_13, [
                          _createVNode(_unref(BaseToolTip), {
                            effect: "light",
                            content: "长按拖动选项",
                            enterable: false,
                            disabled: isDrag.value
                          }, {
                            default: _withCtx(() => [
                              _hoisted_14
                            ]),
                            _: 1
                          }, 8, ["disabled"]),
                          _createVNode(_unref(BaseToolTip), {
                            content: item.label,
                            "over-show": "",
                            enterable: false,
                            style: _normalizeStyle(overStyle.value)
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(item.label), 1)
                            ]),
                            _: 2
                          }, 1032, ["content", "style"])
                        ]),
                        _createVNode(_unref(BaseButton), {
                          type: "default",
                          link: ""
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_unref(BaseIcon), {
                              style: {"color":"#898989"},
                              size: "16",
                              onClick: ($event: any) => (onDeleteItem(item.prop, item))
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_unref(Close))
                              ]),
                              _: 2
                            }, 1032, ["onClick"])
                          ]),
                          _: 2
                        }, 1024)
                      ])
                    ]),
                    _: 1
                  }, 8, ["list"])
                ]),
                _: 1
              })
            ])
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})